/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface DelegateRobloxSecretStoreAccessResponseContent
 */
export interface DelegateRobloxSecretStoreAccessResponseContent {
    /**
     * 
     * @type {string}
     * @memberof DelegateRobloxSecretStoreAccessResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the DelegateRobloxSecretStoreAccessResponseContent interface.
 */
export function instanceOfDelegateRobloxSecretStoreAccessResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function DelegateRobloxSecretStoreAccessResponseContentFromJSON(json: any): DelegateRobloxSecretStoreAccessResponseContent {
    return DelegateRobloxSecretStoreAccessResponseContentFromJSONTyped(json, false);
}

export function DelegateRobloxSecretStoreAccessResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegateRobloxSecretStoreAccessResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function DelegateRobloxSecretStoreAccessResponseContentToJSON(value?: DelegateRobloxSecretStoreAccessResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

